<template>
  <div>
    <SubSideMenu
      :subsection="'SiteCommand'"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SubSideMenu from "@/components/SideMenu/SubSideMenu/SubSideMenu.vue"

export default {
  name: "SiteCommandSideBar",
  components: {
    SubSideMenu
  },
  computed: {
    ...mapGetters(["siteCommandNav"]),
    options() {
      return this.siteCommandNav
    }
  }
}
</script>